import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { legacyWorkspaceSearch } from './-search'

// The chat index never rendered: it resolved the most recent chat and sent the reader
// there. The workspace does that now, from its own address, so this is a translation of
// the old URL rather than a resolution of anything. ADR-167.
export const Route = createFileRoute('/_auth/$orgSlug/$projectId/chat/')({
  validateSearch: z.record(z.string(), z.unknown()),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$orgSlug/$projectId/workspace',
      params: { orgSlug: params.orgSlug, projectId: params.projectId },
      search: legacyWorkspaceSearch(search),
      replace: true
    })
  },
  component: () => null
})
